import { render, staticRenderFns } from "./ProfileEv.vue?vue&type=template&id=0311b309&lang=pug&"
import script from "./ProfileEv.vue?vue&type=script&lang=ts&"
export * from "./ProfileEv.vue?vue&type=script&lang=ts&"
import style0 from "./ProfileEv.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
